import { DATING_EVENTBRITE_SUB_CATEGORY } from '@eventbrite/categories';
import React from 'react';
import styles from './CategoryBrowseBackground.module.scss';

const BackgroundClassMap: { [key: string]: string } = {
    [DATING_EVENTBRITE_SUB_CATEGORY]: styles.datingBackground,
};

export const CategoryBrowseBackground = ({
    activeCategory,
    children,
}: {
    activeCategory: string;
    children: React.ReactNode;
}) => {
    const backgroundClass = BackgroundClassMap[activeCategory] || '';
    return (
        <>
            <div className={`${styles.root} ${backgroundClass}`}></div>
            {children}
        </>
    );
};
